import React from 'react'
import { InstancesProps } from './Types'
import './Styles.scss'
import { faEdit, faPlus, faTrash } from '@fortawesome/free-solid-svg-icons'
import { useInstancesDialogHook } from './components/Dialog/hooks'
import DialogInstancesComponent from './components/Dialog'
import SevenSignalGrid from '../../shared/7Signal/SevenSignalGrid'
import { SevenSignal } from '../../shared/7Signal/SevenSignalGrid/Types'
import ConfirmationComponent from '../../components/confirm'
import { useConfirmHook } from '../../components/confirm/hooks'
import { useGlobalContext } from '../../commonResources/GlobalContextProvider'

export const clearCheckbox = (instanceContext, setIsEditing) => {
  instanceContext.itemsSelected = []
  setIsEditing(false)
}

const InstancesComponent = (props: InstancesProps) => {
  const { instanceContext } = useGlobalContext()
  const dialogHookData = useInstancesDialogHook({
    toggleDialog: props.toggleDialog,
    fetchData: props.fetchData,
    accessToken: props.accessToken,
    isEditing: props?.isEditing,
    showDialog: props.showDialog,
    editData: props.editData,
    clearCheckbox: () => clearCheckbox(instanceContext, props.setIsEditing),
  })

  const confirmProps = useConfirmHook()

  const leftTableButtons: SevenSignal.TableButtons[] = [
    {
      title: 'Add',
      name: 'Add',
      onClick: props.addSapphireInstance,
      className: 'instances-button',
      hasFontAwesomeIcon: true,
      disabled: false,
      icon: faPlus,
    },
    {
      title: 'Edit Changes',
      name: 'Edit',
      onClick: () => props.editSapphireInstance(),
      className: 'instances-button',
      hasFontAwesomeIcon: true,
      disabled: props.shouldDisableButton(),
      icon: faEdit,
    },
    {
      title: 'Delete Changes',
      name: 'Delete',
      onClick: () => {
        props.handleConfirmDelete(props.editData)
        confirmProps.handleIsVisibleToggle()
      },
      className: 'instances-button',
      hasFontAwesomeIcon: true,
      disabled: props.shouldDisableButton(),
      icon: faTrash,
    },
  ]

  const columns: SevenSignal.Columns[] = [
    {
      field: props.SELECTED_FIELD,
      width: '50px',
      filterable: false,
      headerSelectionValue:
        props.data?.findIndex((item) => !props.idGetter(item)) === -1,
    },
    {
      field: 'hostname',
      title: 'Hostname',
    },
    {
      field: 'ipAddress',
      title: 'IP Address',
    },
    {
      field: 'defaultPort',
      title: 'Default Port',
    },
    {
      field: 'prodPort',
      title: 'Prod Port',
    },
  ]

  return (
    <div className="page" data-testid={'instances-table'}>
      <h1 className="page-header__text">Instances</h1>
      <SevenSignalGrid
        sortable={{
          allowUnsort: true,
          mode: 'single',
        }}
        sort={props.sort}
        skip={props.page.skip}
        take={props.page.take}
        total={props.pageSizeValue}
        handleSortChange={props.sortChange}
        handleDisable={props.shouldDisableButton()}
        data={props.data?.map((item) => ({
          ...item,
          [props.SELECTED_FIELD]: props.selectedState[props.idGetter(item)],
        }))}
        dataItemKey={'id'}
        rowHeight={50}
        selectable={{
          enabled: true,
          drag: false,
          cell: false,
          mode: 'multiple',
        }}
        leftTableButtons={leftTableButtons}
        columns={columns}
        sortChange={props.sortChange}
        idGetter={props.idGetter}
        onSelectionChange={props.onSelectionChange}
        onHeaderSelectionChange={props.onHeaderSelectionChange}
        onPageChange={props.pageChange}
      />
      {confirmProps.confirmIsVisible && (
        <ConfirmationComponent
          message={props.confirmDeleteMessage}
          onAbort={() => {
            confirmProps.handleIsVisibleToggle()
          }}
          onConfirm={() => {
            props.deleteSapphireInstance()
            confirmProps.handleIsVisibleToggle()
          }}
        ></ConfirmationComponent>
      )}
      {props.showDialog && <DialogInstancesComponent {...dialogHookData} />}
    </div>
  )
}

export default InstancesComponent
